
<app-toast></app-toast>
<!-- <app-home *ngIf="isHomeRoute"></app-home> -->
<div>
  <router-outlet></router-outlet>
</div>

